import { render, staticRenderFns } from "./ClienteNovoDialog.vue?vue&type=template&id=64e70474"
import script from "./ClienteNovoDialog.vue?vue&type=script&lang=ts"
export * from "./ClienteNovoDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports